/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Delivery/read status of a direct message
 * @export
 */
export const DirectMessageStatus = {
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    READ: 'READ'
} as const;
export type DirectMessageStatus = typeof DirectMessageStatus[keyof typeof DirectMessageStatus];


export function instanceOfDirectMessageStatus(value: any): boolean {
    for (const key in DirectMessageStatus) {
        if (Object.prototype.hasOwnProperty.call(DirectMessageStatus, key)) {
            if (DirectMessageStatus[key as keyof typeof DirectMessageStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DirectMessageStatusFromJSON(json: any): DirectMessageStatus {
    return DirectMessageStatusFromJSONTyped(json, false);
}

export function DirectMessageStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectMessageStatus {
    return json as DirectMessageStatus;
}

export function DirectMessageStatusToJSON(value?: DirectMessageStatus | null): any {
    return value as any;
}

export function DirectMessageStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DirectMessageStatus {
    return value as DirectMessageStatus;
}

